import sms from "@/api/sms";

const getDefaultState = () => ({
  SMSTemplates: [],
  previewSMSContent: '',
  SMSErr: false,
  SMSLoading: false,
  previewSmsErr: false,
  previewSmsloading: false,
  sendSmserr: false,
  sendSmsloading: false,
});

const state = getDefaultState();

const mutations = {
  SMS_TEMPLATES(state, payload) {
    state.SMSTemplates = payload;
    state.SMSLoading = false;
    state.SMSErr = false;
  },

  SMS_TEMPLATES_ERR(state) {
    state.SMSErr = true;
    state.SMSLoading = false;
  },

  PREVIEW_SMS(state, payload) {
    state.previewSMSContent = payload;
    state.previewSmsloading = false;
    state.previewSmsErr = false;
  },

  PREVIEW_SMS_ERR(state) {
    state.previewSmsErr = true;
    state.previewSmsloading = false;
  },

  SEND_SMS(state, payload) {
    state.sendSmsloading = false;
    state.sendSmserr = false;
  },

  SEND_SMS_ERR(state) {
    state.sendSmserr = true;
    state.sendSmsloading = false;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
}

const actions = {
  async loadSMSTemplates({ commit }, {kind, sub_kind}) {
    try {
      const response = await sms.loadSMSTemplates(kind, sub_kind);
      commit("SMS_TEMPLATES", response.data);
    } catch (e) {
      commit("SMS_TEMPLATES_ERR");
    }
  },

  async previewSMSTemplate({ commit }, {template_id, kind, instance_id}) {
    try {
      const response = await sms.previewSMSTemplate(template_id, kind, instance_id);
      commit("PREVIEW_SMS", response.data.template);
    } catch (e) {
      commit("PREVIEW_SMS_ERR");
    }
  },

  async sendSMS({ commit }, {template_id, kind, instance_id}) {
    try {
      const response = await sms.sendSMS(template_id, kind, instance_id);
      commit("SEND_SMS", response.data);
    } catch (e) {
      commit("SEND_SMS_ERR");
    }
  },

  resetState({ commit }) {
    commit("RESET_STATE");
  }
}

const getters = {
  // getProductNotesTypes: (state) => state.productNoteTypes,
  // getProductNotes: (state) => state.productNotes,
  // getProductNotesErr: (state) => state.productNotesErr,
  // getProductNotesLoading: (state) => state.productNotesLoading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
